module.exports = __webpack_public_path__ + "14707bc2aec91fc8aa09ca79022c656f.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/mastercard.svg
// module id = 415
// module chunks = 0